import { asMultiStyleConfig } from '../../utils/theme';
import { getColor } from '../../theme-tools';
var parts = ['colorList', 'colorItem'];
var colorItem = props => {
  var {
    theme
  } = props;
  return {
    h: 8,
    w: 8,
    borderRadius: '.25rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    _pressed: {
      border: "3px solid ".concat(getColor(theme, 'blue.600'))
    },
    _focus: {
      outline: 'none',
      boxShadow: "0 0 0.1875rem 0.125rem ".concat(getColor(theme, 'blue.300')),
      border: "1px solid ".concat(getColor(theme, 'blue.600'))
    }
  };
};
var baseStyle = props => {
  return {
    colorList: {
      display: 'grid',
      gridTemplateRows: 'repeat(5, 2rem)',
      gridAutoFlow: 'column',
      gridGap: '4px',
      minWidth: 0,
      padding: 4,
      boxShadow: 'base'
    },
    colorItem: colorItem(props)
  };
};
export default asMultiStyleConfig({
  parts,
  baseStyle
});